// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73dabd9c","453":"be3a3422","667":"318805a8"}[chunkId] + ".chunk.js";
};